import React, { useEffect, useState } from "react";
import { Box, Typography, Container, Grid } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import br from '../assets/images/bottom.png';

const CMS_URL = process.env.REACT_APP_CMS_URL || 'http://localhost:3000';

function App() {
  const [leadershipData, setLeadershipData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams({
      'where[site][equals]': process.env.REACT_APP_SITE_ID || '1',
      'depth': '2',
      'draft': 'false',
      'limit': '1',
    });
    fetch(`${CMS_URL}/api/leadership-page?${params.toString()}`)
      .then(res => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then(data => {
        setLeadershipData(data.docs?.[0] || null);
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to fetch leadership data:', err);
        setLoading(false);
      });
  }, []);

  const heroBg = !loading && leadershipData?.heroBannerImage?.url
    ? leadershipData.heroBannerImage.url
    : require('../assets/images/Thirukadayur.jpg');

  const chairman = leadershipData?.chairman || null;
  const chairmanPhoto = chairman?.photo?.url || null;
  const chairmanSlides = chairman?.slides?.length
    ? chairman.slides
    : [{ content: '' }]; // fallback so Swiper always has at least one slide

  const teamMembers = leadershipData?.leaders || [];

  return (
    <Box>
      {/* Hero Banner */}
      <Box
        sx={{
          backgroundImage: `url(${heroBg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center top 10%",
          height: "80vh",
          width: "100vw",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          color: "white",
          position: "relative",
        }}
      >
        <Box sx={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0, 0, 0, 0.4)" }} />
        <Typography sx={{ fontWeight: "bold", zIndex: 1, color: "#FFCC03", fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem", lg: "3.5rem", xl: "4rem" }, textAlign: "center", px: 2 }}>
          {leadershipData?.heading || 'Leadership'}
        </Typography>
        <Typography sx={{ fontWeight: "bold", zIndex: 1, mt: 2, color: "white", fontSize: { xs: "1.2rem", sm: "1.5rem", md: "1.75rem", lg: "2rem", xl: "2.25rem" }, textAlign: "center", px: 2 }}>
          Guiding with vision, innovation, and excellence.
        </Typography>
      </Box>

      {/* Chairman Section */}
      {!loading && chairman && (
        <Box sx={{ backgroundColor: "#f8f9e9", py: 6 }}>
          <Container>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={6} display="flex" justifyContent="center">
                {chairmanPhoto ? (
                  <Box
                    component="img"
                    src={chairmanPhoto}
                    alt={chairman.name}
                    sx={{ width: "80%", maxWidth: "250px", height: "auto", maxHeight: "300px", objectFit: "cover", borderRadius: "8px", boxShadow: 3 }}
                  />
                ) : null}
              </Grid>
              <Grid item xs={12} md={6}>
                <Box sx={{ textAlign: "center", width: "85%" }}>
                  <Typography variant="h2" sx={{ fontWeight: "bold", color: "#E52029", fontSize: "34px" }}>
                    {chairman.title} <br />
                    <span style={{ color: "#FAD707" }}>{chairman.name}</span>
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sx={{ position: "relative" }}>
                <Swiper
                  navigation={{ prevEl: ".custom-prev", nextEl: ".custom-next" }}
                  autoplay={{ delay: 90000, disableOnInteraction: false }}
                  loop={chairmanSlides.length > 1}
                  modules={[Navigation, Autoplay]}
                >
                  {chairmanSlides.map((slide, i) => (
                    <SwiperSlide key={i}>
                      <Typography variant="body1" sx={{ mt: 5, fontSize: "16px", color: "#000000", fontWeight: 500, lineHeight: 2, textAlign: "justify", px: 2 }}>
                        {slide.content}
                      </Typography>
                    </SwiperSlide>
                  ))}
                </Swiper>
                <button className="custom-prev" style={{ position: "absolute", top: "50%", left: "0px", transform: "translateY(-50%)", background: "transparent", color: "black", padding: "10px", borderRadius: "50%", zIndex: 10, border: "none", cursor: "pointer", fontSize: "20px" }}>❮</button>
                <button className="custom-next" style={{ position: "absolute", top: "50%", right: "-10px", transform: "translateY(-50%)", background: "transparent", color: "black", padding: "10px", borderRadius: "50%", zIndex: 10, border: "none", cursor: "pointer", fontSize: "20px" }}>❯</button>
              </Grid>
            </Grid>
          </Container>
          <Box sx={{ position: "relative", left: "50%", width: "40%", height: { xs: "100px", md: "150px" }, backgroundImage: `url(${br})`, backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center", marginTop: { xs: "-50px", md: "-100px" }, zIndex: 0 }} />
        </Box>
      )}
      {/* Team Members */}
      <Box sx={{ backgroundColor: "#f8f9e9", py: 6, textAlign: "center" }}>
        <Typography variant="h4" sx={{ fontWeight: "bold", fontSize: "34px", color: "#FAD707" }}>
          <span style={{ color: "red" }}>Team</span> Members
        </Typography>

        {loading && <Typography sx={{ mt: 4 }}>Loading...</Typography>}

        {!loading && teamMembers.length === 0 && (
          <Typography sx={{ mt: 4, color: "#666" }}>No team members found.</Typography>
        )}

        {!loading && teamMembers.length > 0 && (
          <Container sx={{ mt: 4, position: "relative" }}>
            <Swiper
              spaceBetween={30}
              slidesPerView={1}
              loop={true}
              autoplay={{ delay: 21000, disableOnInteraction: false }}
              navigation={{ prevEl: ".custom-prev1", nextEl: ".custom-next1" }}
              modules={[Navigation, Autoplay]}
              breakpoints={{
                640: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
            >
              {teamMembers.map((member, index) => (
                <SwiperSlide key={member.id || index}>
                  <Box sx={{ backgroundColor: "#f8f9e9", boxShadow: 0, borderRadius: "12px", p: 3, textAlign: "center", minHeight: "590px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between", gap: 2 }}>
                    {member.photo?.url && (
                      <Box
                        component="img"
                        src={member.photo.url}
                        alt={member.name}
                        sx={{ width: "200px", height: "200px", objectFit: "cover", borderRadius: "4px" }}
                      />
                    )}
                    <Typography variant="h6" sx={{ fontWeight: "bold", color: "#E52029" }}>
                      {member.name}
                    </Typography>
                    <Typography variant="body1" sx={{ color: "#666", fontWeight: "bold" }}>
                      {member.role}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#333", textAlign: "justify", flexGrow: 1 }}>
                      {member.description}
                    </Typography>
                  </Box>
                </SwiperSlide>
              ))}
            </Swiper>
            <button className="custom-prev1" style={{ position: "absolute", top: "50%", left: "10px", transform: "translateY(-50%)", background: "#f8f9e9", padding: "10px", borderRadius: "50%", zIndex: 10, border: "none", cursor: "pointer", fontSize: "16px" }}>❮</button>
            <button className="custom-next1" style={{ position: "absolute", top: "50%", right: "10px", transform: "translateY(-50%)", background: "#f8f9e9", padding: "10px", borderRadius: "50%", zIndex: 10, border: "none", cursor: "pointer", fontSize: "16px" }}>❯</button>
          </Container>
        )}
      </Box>
    </Box>
  );
}

export default App;